import { logger } from '@gem/modules/logger';

import { buildModelError } from 'APP/model/error/errorBuilder';
import { IMarket } from 'APP/model/market/marketModel.types';

// Needs Bff implementation
export const getCoinFide = async (): Promise<IMarket> => {
  try {
    return {} as IMarket;
  } catch (error) {
    logger.get('API').error('pi.marketplace.getCoinfideUrl', error);
    throw buildModelError(error);
  }
};
